import React from '../../vendor/react';
import { CircleDollarSign, LayoutDashboard, Menu, ShoppingCart, Store } from '../../vendor/lucide-react';
import { NavLink, useLocation } from '../../vendor/react-router-dom';

const links = [
  { to: '/app', label: 'Inicio', icon: LayoutDashboard, end: true },
  { to: '/app/pos', label: 'Cobrar', icon: ShoppingCart },
  { to: '/app/ventas', label: 'Ventas', icon: CircleDollarSign },
  { to: '/app/productos', label: 'Productos', icon: Store },
];

export function MobileBottomNav({ onOpenMenu }: { onOpenMenu: () => void }) {
  const location = useLocation();
  return <nav className="mobile-bottom-nav" aria-label="Accesos principales">
    {links.map((item) => { const Icon = item.icon; return <NavLink key={item.to} to={item.to} end={item.end} className={({ isActive }) => isActive ? 'is-active' : ''}><Icon size={20} /><span>{item.label}</span></NavLink>; })}
    <button className={location.pathname === '/app/configuracion' ? 'is-active' : ''} onClick={onOpenMenu}><Menu size={20} /><span>Más</span></button>
  </nav>;
}
